import { createApp } from 'vue';
import DownloadsListing from './components/DownloadsListing.vue';
import LangSwitch from './components/LangSwitch.vue';
import ProductsListing from './components/ProductsListing.vue';

// Helper function to initialize Vue apps
const initializeVueApp = (selector, component) => {
    const elements = document.querySelectorAll(selector);
    elements.forEach((el) => {
        const app = createApp(component);
        app.mount(el);
    });
};

// Initialize all Vue apps
initializeVueApp('[data-vue-downloads-listing]', DownloadsListing);
initializeVueApp('[data-vue-lang-switch]', LangSwitch);
initializeVueApp('[data-vue-products-table]', ProductsListing);